import {Component, OnInit} from '@angular/core';
import {VorhersageHeute, VorhersageTag, VorhersageZehnTage} from '../../../../../../model/vorhersagen/vorhersage-zehn-tage';
import {DatastoreService} from '../../../../../../service/datastore/datastore.service';
import {ActivatedRoute} from '@angular/router';
import {first, map, take} from 'rxjs/operators';
import {FirebaseService} from '../../../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-vierundzwanzig-stunden-vorhersage',
  templateUrl: './vierundzwanzig-stunden-vorhersage.component.html',
  styleUrls: ['../vorhersagen-table-styles.css']
})
export class VierundzwanzigStundenVorhersageComponent implements OnInit {

  selectedVorhersage: VorhersageZehnTage;
  vorhersageTagHeute: VorhersageHeute;
  isLoading = false;

  //TODO: MAN MUSS NOCH DEN AKTUELLEN TAG HOLEN

  constructor(private datastoreService: DatastoreService,
              private firebaseService: FirebaseService,
              private route: ActivatedRoute,
              private snackbar: MatSnackBar) {
  }

  ngOnInit() {
    //Die computer-mos Komponente übergibt beim Routing auf die Details den Namen/Id der Station als Parameter,
    // der bei der Initialisierung ausgelesen wird und das entsprechenden Objekt herausgeholt
    this.route.queryParams.pipe(first()).subscribe(params => {
      if (params.id !== null && params.id !== undefined) {
        this.isLoading = true;
        this.getZehnTageVorhersagen24h(params.id);
        if (this.datastoreService.vorhersagen24hHeute !== undefined) {
          this.vorhersageTagHeute = this.datastoreService.vorhersagen24hHeute.find(value => value.ort.id === params.id);
        }
      }
    });
  }

  private getZehnTageVorhersagen24h(id: string) {
    return this.firebaseService.getVorhersagenDeutschland10Tage24hByID(id)
      .pipe(take(1), map(data => this.datastoreService.mapDataTo24hZehnTageVorhersagen(data)))
      .subscribe((data) => {
        this.selectedVorhersage = this.datastoreService.vorhersagen24hZehnTage[0];
        this.selectedVorhersage.tag00 = new VorhersageTag();
        this.selectedVorhersage.tag00.werteGanzerTag = this.vorhersageTagHeute.tag00.werteGanzerTag;
        this.isLoading = false;
      }, error => {
        this.snackbar.open(`ERROR: Kann Vorhersagen nicht laden ${error}`);
        this.isLoading = false;
      });
  }
}
